var Formats  = {
	TYPES: {
		// "AvatarCustomizerFormat": {
		// 	name: "Avatar Customizer"
		// },
		"CollageFormat": {
			name: "Collage"
		},
		"DragDropFormat": {
			name: "Drag & Drop"
		},
		"DrawingFormat": {
			name: "Drawing"
		},
		"GraphicOrganizerFormat": {
			name: "Graphic Organizer"
		},
		// "ReviewFormat": {
		// 	name: "Review a Book"
		// },
		"ImagePromptFormat": {
			name: "Image Prompt"
		},
		"ExternalLinkFormat": {
			name: "External Link"
		},
		"VocabContextFormat": {
			name: "Vocabulary"
		},
		"ShortPassageFormat": {
			name: "Short Passage"
		},
		// "ComicFormat": {
		// 	name: "Comic Strip"
		// },
		"EvaluateResponseFormat": {
			name: "Evaluate a Response"
		},
		// "ShortPromptFormat": {
		// 	name: "Respond to a Question"
		// },
		"MultiStepFormat": {
			name: "Multi Steps"
		},
		// "VoiceFormat": {
		// 	name: "Voice Recording"
		// },
	},

	getName: function(formatKey) {
		var format = Formats.TYPES[formatKey];
		if (format) { return format.name; }
	},

	isCollaboration: function(formatKey) {
		return formatKey == "CollaborationFormat";
	}
}

module.exports = Formats;



// WEBPACK FOOTER //
// ./modules/lib/academic/Formats.js